import { WishlistButton } from "@omni/components/components/Navigation/Buttons/WishlistButton/wishlistButton";

import { HeaderButtonComponent } from "@/components/Navigation/Buttons/HeaderButton/headerButton.component";

export const WishlistButtonComponent = () => {
    const { headerButtonProps } = WishlistButton.useContext();

    return (
        <>
            <HeaderButtonComponent
                {...headerButtonProps}
                invertMobile={true}
                hover={true}
                iconPrefix={"lar"}
            />
            <WishlistButton.Message />
        </>
    );
};
